import Backbone from 'backbone'
import _ from 'lodash'
import { EditableCanvas }  from 'canvas'
import testWobs from './test-wobs'
import Wobs from 'scoreboard/dashboards/display/wobs'
import widgetTypes from 'scoreboard/dashboards/widgets/all'
import template from './test-dashboard-widgets.hbs'

var DashboardWidgetsView = Backbone.View.extend({
	className: 'admin table-hack display-layout admin-test-view admin-test-dashboard-widgets',

	render: function() {
		this.$el.append(template())

		// Create and populate the canvas with test wobs
		this.canvas = new EditableCanvas({
			collection: new Wobs(
				testWobs,
				{
					dashboard: 0,//this.model.cid,
					widgetTypes: widgetTypes,
					section: 'section'//this.model.get('section')
				}
			),
			minHeight: 500,
			minWidth: 500
		})

		this.canvas.use(Canvas.features.edges)
		this.canvas.use(Canvas.features.draggable)
		this.canvas.use(Canvas.features.droppable.bind(null, {
			uploadMessage: 'Test Upload (this wont work)'
		}))
		this.canvas.use(Canvas.features.marquee)
		this.canvas.use(Canvas.features.keybindings)

		this.$('.canvas-container').append(this.canvas.el)
		this.canvas.build().render()
	},
	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.canvas], 'remove')
	}
})

export default DashboardWidgetsView
